// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const SuccessAlert: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18Zm-1.862-4.235L3.364 9.991a.58.58 0 0 1 0-.821l.82-.821a.58.58 0 0 1 .822 0l2.542 2.542 5.446-5.445a.58.58 0 0 1 .821 0l.821.82a.58.58 0 0 1 0 .822L7.96 13.765a.58.58 0 0 1-.821 0Z"
            />
        </svg>
    );
};

export default React.memo(SuccessAlert);
